import { action, computed, observable } from "mobx";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";
import { EmailModel } from "Custom/Models/Domain/ProductSelector/Email";
import { validate, ValidationError } from "class-validator";
import { FieldType } from "Core/Utils/Utils";
import { StoresInstance } from "Custom/Stores/Stores";
import { AccountStore, ErrorStore } from "Custom/Stores/Domain";
import { DomainStores } from "Custom/Stores";
import { ProductSelectorModel } from "Custom/Models/Domain/ProductSelector/ProductSelectorModel";

export default class EmailViewModel extends ViewModelBase<EmailModel> {
    private productSelectorModel: ProductSelectorModel;
    private domainStore: DomainStores = StoresInstance.domain;
    private accountStore: AccountStore = StoresInstance.domain.AccountStore;
    private errorStore: ErrorStore = StoresInstance.domain.ErrorStore;
    private sendEmailCallback: () => Promise<void>;

    constructor(callback: () => Promise<void>, productSelectorModel: ProductSelectorModel) {
        super(new EmailModel());
        this.setDecorators(EmailModel);

        this.model.email = this.accountStore.userEmail;
        this.sendEmailCallback = callback;
        this.productSelectorModel = productSelectorModel;
    }

    @observable
    public haveSubmitted = false;

    @action
    public setHaveSubmitted = (value: boolean): void => {
        this.haveSubmitted = value;
    };

    @computed
    public get projectName(): string {
        return this.model.projectName;
    }

    @computed
    public get showResetButton(): boolean {
        return this.domainStore.showResetButton;
    }

    @action
    public setProjectName = (value: string): void => {
        this.model.projectName = value;
    };

    @computed
    public get email(): string {
        return this.model.email;
    }

    @computed
    public get projectNameError(): string {
        const result = this.validateDecorators("projectName");
        return !this.haveSubmitted ? "" : result.isValid ? "" : result.errorMessage;
    }

    @action
    public sendEmail = async (): Promise<void> => {
        this.setHaveSubmitted(true);

        const productErrors = await this.productSelectorModel.Validate();
        const localErrors = await validate(this.model);

        if (localErrors.length === 0 && productErrors.length === 0) {
            this.accountStore.setEmailData(this.model.email, this.model.projectName);
            await this.sendEmailCallback();
        } else {
            console.log("validation failed");
        }
    };

    @action
    public reset = async (): Promise<void> => {
        this.accountStore.resetUser();
    };

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<EmailModel>): boolean {
        const { isValid, errorMessage } = this.validateDecorators(fieldName);

        // You need to this two properties after validation
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    // #endregion Viewmodel Boilerplate
}
